// Form1.js

import React, { useState } from "react";
import "./form.css"; // Import the CSS file for styling
import axios from "axios";

const Form1 = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "", // Updated to camelCase
    roles: "", // Updated to camelCase
    location: "", // Updated to camelCase
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://sheet.best/api/sheets/4742d737-cab3-4fc6-b274-37baae036e24",
        formData
      );
      console.log("API Response:", response);
      if (response.status === 200) {
        setFormData({ name: "", email: "", phoneNumber: "", roles: "", location: "" });
        alert("Form submitted successfully!");
      } else {
        console.error("Failed to submit form. Unexpected status:", response.status);
        alert("Failed to submit form. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form. Please try again.");
    }
  };

  return (
    <div className="form-container">
      <div className="form-header">Apply Online!</div>
      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-field">
          <label htmlFor="email">E-mail</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-field">
          <label htmlFor="phoneNumber">Phone Number</label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-field">
          <label htmlFor="roles">Roles</label>
          <input
            type="text"
            id="roles"
            name="roles"
            value={formData.roles}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-field">
          <label htmlFor="location">Location</label>
          <input
            type="text"
            id="location"
            name="location"
            value={formData.location}
            onChange={handleInputChange}
          />
        </div>

        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>
    </div>
  );
};

export default Form1;
